import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { PrivateNumberBuyRequestStatus } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { LoggerService } from 'src/app/core/services/logger.service';

@Directive({
  selector: '[privateNumberBuyRequestStatus]',
  standalone: true,
})
export class PrivateNumberBuyRequestStatusDirective implements OnInit {
  @Input('privateNumberBuyRequestStatus') status: PrivateNumberBuyRequestStatus;

  constructor(
    private element: ElementRef<HTMLElement>,
    private loggerService: LoggerService
  ) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }
  ChildrenPrivateNumberBuyRequestsPaginationDto;

  getCssClassList(): string {
    try {
      let classList = 'mdi tw-font-medium mdi-20px ';

      switch (this.status) {
        case PrivateNumberBuyRequestStatus.CertainAssignment:
          classList += ' mdi-check-bold text-success';
          break;
        case PrivateNumberBuyRequestStatus.PrivateNumberAlreadyExisted:
          classList += ' mdi-sim text-blue';
          break;
        case PrivateNumberBuyRequestStatus.Rejected:
          classList += ' mdi-close-thick text-danger';
          break;
        case PrivateNumberBuyRequestStatus.Pending:
          classList += ' mdi-circle-slice-4 text-warning mdi-spin';
          break;
        case PrivateNumberBuyRequestStatus.WaitingDocumentsUpload:
          classList += ' mdi-circle-slice-4 text-info mdi-spin';
          break;
        case PrivateNumberBuyRequestStatus.Reserved:
          classList += ' mdi-content-save-check-outline text-pink ';

          break;

        default:
          break;
      }
      return classList;
    } catch (error) {
      this.loggerService.logError(
        'privateNumberBuyRequestStatus',
        error,
        EventTypes.privateNumberPrice
      );
    }
  }
}
